import React, { FC } from 'react';
import Nav from '@fiverr-private/header/src/lib/Nav';
import Layout from '@fiverr-private/header/src/components/Layout';
import MainRow from '@fiverr-private/header/src/components/MainRow';
import UserAvatar from '@fiverr-private/header/src/components/UserAvatar';
import HelpLink from '@fiverr-private/header/src/components/LogoMakerLinks/HelpLink';
import LogoutLink from '@fiverr-private/header/src/components/LogoutLink';
import FiverrLink from '@fiverr-private/header/src/components/FiverrLink';
import withContext from '@fiverr-private/header/src/lib/withContext';
import { User } from '../../../../shared/types';
import EducHubLogo from './EducateHubLogo';
import { Navicon } from './Navicon';
import GoToFiverrLink from './GoToFiverrLink';

import './style.scss';

const EducateHubLoggedInHeader: FC<{ user: User }> = ({ user }) => (
  <Layout className="educate-hub-header">
    <MainRow>
      <Navicon />
      <EducHubLogo />
      <Nav alignToRight>
        <Nav.Item displayFromSM>
          <FiverrLink />
        </Nav.Item>
        <Nav.PopoverItems
          target={<UserAvatar username={user.username} profileImage={user.profileImage} isOnline={user.isOnline} />}
          placement="left"
        >
          <Nav.PopoverItem>
            <GoToFiverrLink />
          </Nav.PopoverItem>
          <Nav.PopoverItem>
            <HelpLink userId={user.id} />
          </Nav.PopoverItem>
          <Nav.PopoverDivider />
          <Nav.PopoverItem>
            <LogoutLink />
          </Nav.PopoverItem>
        </Nav.PopoverItems>
      </Nav>
    </MainRow>
  </Layout>
);

export default withContext(EducateHubLoggedInHeader);
